import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setLoginResonse } from '../../redux/actions/loginResonseActions';
import { pushBookingCustomerLogin } from '../../gtm';



const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    textAlign: 'center',
    color: '#444',
    fontSize: '18px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  title2: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  title3: {
    textAlign: 'center',
    color: '#444',
    fontSize: '26px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  subtitle: {
    textAlign: 'left',
    font: '14px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    marginTop: '20px',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: 'bold',
    fontSize: '1rem',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  spacing: {
    marginTop: '16px',
  },
});


const Login = ({ classes }) => {

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('');

  const [errorMessage, setErrorMessage] = useState('');

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;


  const dispatch = useDispatch();


  const createBookingResponse = useSelector(state => state.createBooking);


  const navigate = useNavigate();

  const handleForgotPasswordClick = () => {
    navigate('/forgot');
  };

  const handleLogin = async (event) => {
    setLoading(true);

    // Get form data
    const data = new FormData(event.currentTarget);

    event.preventDefault();

    // Get form data
    // const data = new FormData(event.currentTarget);

    // Create an object with the login details
    // const loginData = {
    //   user: {
    //     username: data.get('email'),
    //     password: data.get('password')
    //   },
    //   basket: {
    //     guid: quoteResponse ? quoteResponse.basket_id : 'default_value', // Use the saved quoteResponse if available, or provide a default value
    //   },
    // };

    // try {


    //   const response = await fetch('https://api-proxy.qa.lifts.to/api/booking/quote/login', {
    //     method: 'POST',
    //     headers,
    //     body:JSON.stringify(loginData),
    //   });

    //   // Temp
    //   // const response = require('../../dummyDataResponses/loginResponse.json'); // Import the JSON data
    //   console.log("check response",response)
    //   if (response.status_code  === 200) {
    //     // const responseData = await response.json();
    //     // Save the response to Redux
    //     dispatch(setLoginResonse(response));
    //     navigate('/terms')
    //   } else {
    //     // Handle API errors here
    //     console.log('API error:', response);
    //   }
    // } catch (error) {
    //   console.error('API request failed:', error);
    //   // Handle any other errors that may occur during the API call
    // }

    // Gather Booking Customer Login for GTM
    const bookingCutomerLoginDetails = {
      'DLV - TY - Email': data.get('loginEmail')
    };

    // Push the Booking Customer Login to the data layer
    pushBookingCustomerLogin(bookingCutomerLoginDetails);

    const loginData = {
      "user":
          {
            "username": data.get('loginEmail'),
            "password": data.get('password')
          },
      "basket":
          {
            "id": createBookingResponse.basket.guid,
          }
    }

    const headers = {
      'Content-Type': 'application/json'
    };
    fetch(`${apiBaseUrl}/basket/login`, {
      method: 'POST',
      headers,
      body: JSON.stringify(loginData),
    })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          if (data.status_code && data.status_code !== 200) {
            // Set the error message if status code is not 200
            setErrorMessage('Unable to find user details. Please Check your Email and Password!');
          } else {
            // Proceed with the navigation

            dispatch(setLoginResonse(data));
            navigate('/terms');
          }
        })
        .catch((error) => {
          setLoading(false);
          // console.log('Error fetching drop-off options:', error);
          setErrorMessage('An error occurred while trying to log in.');
        });

  };


  useEffect(() => {
    if (loading) {
      setLoadingText('Logging In');

      return () => {
        // Cleanup logic, if any
      };
    }
  }, [loading]);


  const handleContinueAsGuest = () => {
    navigate('/terms');
  };



  return (
      <div>
        <Grid container spacing={2} sx={{
          flexGrow: 1,
          backgroundColor: '#FCFDFD', textAlign: 'center', marginTop: '16px',
        }}>


          <Grid item xs={12} md={6}  maxWidth="xs" sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '60px'
          }}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Typography variant="h2" sx={{
                textAlign: 'center',
                fontSize: '1.8rem',
                fontWeight: '700',
                color: '#333',
                fontFamily: 'Nexa,sans-serif',
                lineHeight: '1.1',
                marginTop: '16px',
              }}>
                New to Ski Lifts?
              </Typography>
              <Typography variant="h3" sx={{
                textAlign: 'center',
                color: '#444',
                fontSize: '14px',
                fontFamily: 'Nexa,sans-serif',
                fontWeight: 'bold',
                marginTop: '16px',
              }}>
                Please continue as a Guest
              </Typography>
              <Typography variant="p" className={`${classes.subtitle}`}>
                Don’t forget to create a Ski-Lifts account when you've finished booking to start earning loyalty points
              </Typography>
              <div style={{display:'flex', justifyContent:'center'}}>
                <Button
                    id={'continueAsGuestButton'}
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3, mb: 2}}
                    className={classes.button1}
                    style={{display:'flex', justifyContent:'center' }}
                    onClick={handleContinueAsGuest}
                >
                  CONTINUE
                </Button>
              </div>
            </Container>
          </Grid>


          {/* SIGNIN */}

          <Grid item xs={12} md={6} sx={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <Container component="main" maxWidth="xs">
              <CssBaseline />
              <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
              >

                <Typography variant="h2" sx={{
                  textAlign: 'center',
                  fontSize: '1.8rem',
                  fontWeight: '700',
                  color: '#333',
                  fontFamily: 'Nexa,sans-serif',
                  lineHeight: '1.1',
                  marginTop: '16px',
                }}>
                  Sign In - Customer Account
                </Typography>
                <Typography variant="h3" sx={{
                  textAlign: 'center',
                  color: '#444',
                  fontSize: '14px',
                  fontFamily: 'Nexa,sans-serif',
                  fontWeight: 'bold',
                  marginTop: '16px',
                }}>
                  Login to use your loyalty points and receive booking discounts.
                </Typography>
                <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
                  <TextField
                      margin="normal"
                      value={createBookingResponse.basket.transfers[0].email}
                      required
                      fullWidth
                      id="loginEmail"
                      label="Email Address"
                      name="loginEmail"
                      autoComplete="loginEmail"
                      autoFocus
                      InputLabelProps={{
                        shrink: !!createBookingResponse.basket.transfers[0].email,
                      }}
                  />
                  <TextField
                      margin="normal"
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="current-password"
                  />
                  {errorMessage && (
                      <Typography color="error" style={{ marginTop: 16 }}>
                        {errorMessage}
                      </Typography>
                  )}

                  {loading ? (
                          // Display loading state with text and circular progress
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '15px', marginBottom: '15px' }}>
                            <CircularProgress size={24} style={{ color: 'grey', marginRight: '8px' }} />
                            <Typography variant="body1" style={{ fontWeight: 'bold', fontSize: '1.0rem', color: 'grey' }}>
                              {loadingText}
                            </Typography>
                          </div>
                      )
                      : (<div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                  mt: 3, mb: 2,
                                  backgroundColor: 'rgb(17, 137, 17)',
                                  color: 'rgb(255, 255, 255)',
                                  borderRadius: '6px',
                                  marginTop: '14px',
                                  padding: '0px 50px',
                                  fontFamily: '"Nexa","Arial",sans-serif!important',
                                  fontWeight: 'bold',
                                  fontSize: '1rem',
                                  lineHeight: '1.75',
                                  letterSpacing: '0.02857em',
                                  minWidth: '183px',
                                  minHeight: '50px',
                                  display: 'flex',
                                }}

                                style={{ display: 'flex', justifyContent: 'center' }}
                            >
                              SIGN IN
                            </Button>
                          </div>
                      )}
                  <Grid container>
                    <Grid item xs>
                      <Link href="#" variant="body2" onClick={handleForgotPasswordClick}>
                        <strong>Forgot Password?</strong>
                      </Link>
                    </Grid>

                  </Grid>
                </Box>
              </Box>
            </Container>
          </Grid>

        </Grid>

      </div>
  );
};

export default withStyles(styles, { withTheme: true })(Login);
